
export default {
  name: 'HeaderSimple'
}
